<template>
  <div class="pay-main">
    <div style="padding-top: 50px;">
      <p>项目运营服务案例文档全套</p>
    </div>
    <div style="width: 50%;margin: 0 auto;">
      <el-form ref="form" :model="form" label-width="100px">
        <el-form-item label="接受邮箱：">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="付费阅读：">
          <font style="font-size:24px;" color="red"> 2元/次</font>
        </el-form-item>
      </el-form>
    </div>
    <div style="width: 50%;margin: 0 auto;">
      <img src="../assets/erweima_ba.png"/>
      <p>扫描支付后文档自动发送到您得邮箱</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'pay',
  data () {
    return {
      form: {
          name: '',
          }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.pay-main {
  margin-top: 60px;
  padding-bottom: 120px;
  text-align: center;
}
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/Pay.vue